import { type CreditUsageState } from '~/components/CreditUsageMeter/types';

export type CreditUsageAlertType = 'banner' | 'meterUpsell';

export const getDismissedCreditUsageAlertStorageKey = ({
  workspaceId,
  alertType,
  creditUsageState,
}: {
  workspaceId: string;
  alertType: CreditUsageAlertType;
  creditUsageState: CreditUsageState;
}) => [workspaceId, alertType, creditUsageState].join('.');
